import PaperTypesDialog from './PaperTypesDialog';

export default PaperTypesDialog;
